import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-bir-info-view',
  template: `
    <div>
      <strong>{{ data.code }}</strong>
    </div>
    <br />
    <div>TIN: {{ data.tinNumber }} ({{ data.tinBranchCode }})</div>
    <br />
    <div *ngIf="data.classification === 1">
      {{ data.companyName }}
    </div>
    <div *ngIf="data.classification === 2">
      {{ concatString([data.firstName, data.middleName, data.lastName]) }}
    </div>
    <div> {{ concatString([data.address, data.district, data.zipCode]) }} </div
    ><br />
    <div>
      {{ data.waCategory === 1 ? 'Private' : 'Government' }} |
      {{ data.classification === 1 ? 'Non-Individual' : 'Individual' }}
    </div>
  `,
  standalone: false,
  styles: []
})
export class BirInfoViewComponent implements OnInit {
  @Input() data: any = {};

  constructor() {}

  ngOnInit(): void {
    return;
  }

  concatString(stringValues: string[]) {
    return stringValues.filter(x => x).join(' ');
  }
}
